import useStore from '../useStore';

const useUsersStore = () => {
  const { usersStore } = useStore();

  return usersStore;
};

export default useUsersStore;
